export default __webpack_public_path__ + "static/guatemala-flag-04e31c092654c919862c7df07d1f311f.svg";